module.exports = __webpack_public_path__ + "8402ad7995c3f47a467004ec13410ba3.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/mx.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/mx.svg
// module chunks = 0